import { terminologyConfig } from '../terminology/store';
// ADD this import at the very top of the file
import { URL_SEGMENTS } from './Routesconfig';

const SuperadminConfig = terminologyConfig({

  // ── NAV TAB LABELS ───────────
  nav: {
    resellers: { label: 'Resellers',       icon: 'briefcase-fill'              },
    clients:   { label: 'Users',         icon: 'people-fill'                 },
    reports:   { label: 'Reports',       icon: 'file-earmark-bar-graph-fill' },
    notify:    { label: 'Notify User',   icon: 'bell-fill'                   },
    admins:    { label: 'Admins',        icon: 'buildings-fill'              },
    account:   { label: 'My Account',    icon: 'person-lines-fill'           },
  },

  // ── CLIENTS DROPDOWN ─────────
  clients: {
    core: {
      label:        'Team',
      pageHeading:  'Team Members',
      breadcrumb:   'Team',
      emptyMessage: 'No team members found.',
    },
    enterprise: {
      label:        'Enterprise Client',
      pageHeading:  'Enterprise Clients',
      breadcrumb:   'Enterprise Client',
      emptyMessage: 'No enterprise clients found.',
    },
  },

  // ── REPORTS DROPDOWN ─────────
  reports: {
    user:       { label: 'User Report',       pageHeading: 'User Reports'       },
    commission: { label: 'Commission Report', pageHeading: 'Commission Reports' },
    usage:      { label: 'Usage Report',      pageHeading: 'Usage Reports'      },
  },

  // ── RESELLERS SECTION ────────
  resellers: {
    pageHeading:  'Advisors',
    singular:     'Advisor',
    plural:       'Advisors',
    emptyMessage: 'No advisors found.',
  },

  // ── ADMINS SECTION ───────────
  admins: {
    pageHeading:  'Admins',
    singular:     'Admin',
    plural:       'Admins',
    emptyMessage: 'No admins found.',
  },


  routes: {
    base: '/superadmin',


    resellers: URL_SEGMENTS.resellers,          

 
    addReseller: URL_SEGMENTS.addReseller,       

 
    editReseller: URL_SEGMENTS.editReseller,   


    addClientForReseller: (id) => `reseller/${id}/add-client`,

    admins:  URL_SEGMENTS.admins,                // "admins"
    notify:  URL_SEGMENTS.notify,                // "notify"
    account: URL_SEGMENTS.account,               // "account"

    clients: {
      core:             URL_SEGMENTS.clients,              // "investors"
      enterprise:       URL_SEGMENTS.enterpriseClients,    // "investors-clients"
      detail:           URL_SEGMENTS.editClient,           // "client/edit"
      enterpriseDetail: URL_SEGMENTS.editEnterpriseClient, // "enterprise-client/edit"
    },

    reports: {
      base:    URL_SEGMENTS.reports,             // "reports"
      subKeys: { user: 'user', commission: 'commission', usage: 'usage' },
      legacyPaths: {
        user:       URL_SEGMENTS.userReport,       // "userreport"
        commission: URL_SEGMENTS.commissionReport, // "commission-report"
        usage:      URL_SEGMENTS.usageReport,      // "usage-report"
      },
    },

    nested: {
      resellerHierarchy: `${URL_SEGMENTS.resellers}/${URL_SEGMENTS.hierarchy}`, // "advisors/hierarchy"
      adminDetail:       URL_SEGMENTS.editAdmin,   // "admin/edit"
      notifyLogs:        `${URL_SEGMENTS.notify}/${URL_SEGMENTS.emailLogs}`,    // "notify/logs"
    },
  },

  // ── FEATURE FLAGS ────────────
  features: {
    tabs:    { resellers: true, clients: true, reports: true, notify: true, admins: true, account: true },
    clients: { core: true, enterprise: true },
    reports: { user: true, commission: true, usage: true },
    api:     { autoFetchResellers: true, autoFetchAdmins: true },
  },

  // ── UI TEXT ────
  ui: {
    somethingWentWrong: 'Something went wrong',
    unknownError:       'Unknown error',
  },
}, {
  "resellers.label": [
    "reseller",
    "singular",
    "{name}"
  ],
  "resellers.singular": [
    "reseller",
    "singular",
    "{name}"
  ],
  "resellers.plural": [
    "reseller",
    "plural",
    "{name}"
  ],
  "resellers.pluralLabel": [
    "reseller",
    "plural",
    "{name}"
  ],
  "resellers.pageHeading": [
    "reseller",
    "plural",
    "{name}"
  ],
  "resellers.managementLabel": [
    "reseller",
    "singular",
    "{name} Management"
  ],
  "resellers.emptyMessage": [
    "reseller",
    "plural",
    "No {name} found."
  ],
  "resellers.breadcrumb": [
    "reseller",
    "singular",
    "{name}"
  ],
  "clients.core.label": [
    "client",
    "singular",
    "{name}"
  ],
  "clients.core.singular": [
    "client",
    "singular",
    "{name}"
  ],
  "clients.core.plural": [
    "client",
    "plural",
    "{name}"
  ],
  "clients.core.pluralLabel": [
    "client",
    "plural",
    "{name}"
  ],
  "clients.core.pageHeading": [
    "client",
    "plural",
    "{name}"
  ],
  "clients.core.managementLabel": [
    "client",
    "singular",
    "{name} Management"
  ],
  "clients.core.emptyMessage": [
    "client",
    "plural",
    "No {name} found."
  ],
  "clients.core.breadcrumb": [
    "client",
    "singular",
    "{name}"
  ],
  "nav.resellers.label": [
    "reseller",
    "plural",
    "{name}"
  ],
  "nav.clients.label": [
    "client",
    "plural",
    "{name}"
  ]
});

export default SuperadminConfig;